import React from 'react';
import { useLocation } from 'react-router-dom';
import { HREFLANG, lerPrefixo } from '../config/seo';
import { IDIOMAS, Link, useIdioma } from '../i18n';

/**
 * As três versões da página pública atual. São links de verdade, e não um
 * `<select>`: o robô segue cada um até a versão traduzida, e trocar de idioma
 * aqui só troca de URL — a conta, e o idioma da área logada, ficam onde estão.
 */
const SeletorDeIdioma = () => {
  const { t, idioma } = useIdioma();
  const { caminho } = lerPrefixo(useLocation().pathname);

  return (
    <nav className="seletor-idioma" aria-label={t('site.idioma')}>
      {IDIOMAS.map(({ codigo, nome }) => (
        <Link
          key={codigo}
          to={caminho}
          idioma={codigo}
          lang={codigo}
          hrefLang={HREFLANG[codigo]}
          aria-label={nome}
          aria-current={codigo === idioma ? 'true' : undefined}
        >
          {codigo.toUpperCase()}
        </Link>
      ))}
    </nav>
  );
};

export default SeletorDeIdioma;
